import { FormatValue } from '@features/campaigns';

export const wrapLciValue: FormatValue<string> = value => `<lci>${value}</lci>`;

export const wrapBoldValue: FormatValue<string> = value => `<b>${value}</b>`;

export const addNewlinesToSentences = (text: string) =>
  text.split('. ').join('.\n');
